import Flex, { type FlexProps, type Gap } from './Flex';

export default Flex;
export type { FlexProps, Gap };
